export enum SupportRequestFor {
    CreateReport,
    EditReport,
    CreateScenario,
    EditScenario,
    ViewReport,
}